import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import { InsightsFundingOverviewRoute } from './InsightsFundingOverviewRoute';
import { InsightsLtvRoute } from './InsightsLtvRoute';
import { InsightsBorrowingBaseRoute } from 'borrower/routes/insights/InsightsBorrowingBaseRoute';
import { InsightsConcentrationRoute } from 'borrower/routes/insights/InsightsConcentrationRoute';
import { InsightsEligibilityRoute } from 'borrower/routes/insights/InsightsEligibilityRoute';
import { InsightsExpensesFeesRoute } from 'borrower/routes/insights/InsightsExpensesFeesRoute';
import { InsightsFinancialCovenantsRoute } from 'borrower/routes/insights/InsightsFinancialCovenantsRoute';
import { InsightsPerformanceRoute } from 'borrower/routes/insights/InsightsPerformanceRoute';
import { InsightsPortfolioCovenantsRoute } from 'borrower/routes/insights/InsightsPortfolioCovenantsRoute';

export const InsightsRouter = withLDConsumer()(({ flags }) => {
  return (
    <Switch>
      <Route
        exact
        path="/insights/funding-overview"
        component={InsightsFundingOverviewRoute}
      />
      <Route
        exact
        path="/insights/borrowing-base"
        component={InsightsBorrowingBaseRoute}
      />
      <Route
        exact
        path="/insights/eligibility"
        component={InsightsEligibilityRoute}
      />
      <Route
        exact
        path="/insights/concentration"
        component={InsightsConcentrationRoute}
      />
      <Route
        exact
        path="/insights/performance"
        component={InsightsPerformanceRoute}
      />
      <Route exact path="/insights/ltv" component={InsightsLtvRoute} />
      <Route
        exact
        path="/insights/expenses-fees"
        component={InsightsExpensesFeesRoute}
      />
      <Route
        exact
        path="/insights/financial-covenants"
        component={InsightsFinancialCovenantsRoute}
      />
      {flags?.displayPortfolioCovenants && (
        <Route
          exact
          path="/insights/portfolio-covenants"
          component={InsightsPortfolioCovenantsRoute}
        />
      )}
      <Route exact path="/insights">
        <Redirect from="/insights" to="/insights/funding-overview" />
      </Route>
    </Switch>
  );
});
